import { FormikForm } from '../../Formik'

import { SettingsFormSectionContent } from './SettingsFormSectionContent'

function SettingsFormSection({
  Buttons,
  Guard,
  after,
  bodyClassName,
  buttonsProps,
  children,
  description,
  initialValues,
  qaName,
  saveIgnoredFieldNames,
  title,
  validationSchema,
  onSubmit,
}) {
  return (
    <FormikForm
      enableReinitialize
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <SettingsFormSectionContent
        Buttons={Buttons}
        Guard={Guard}
        bodyClassName={bodyClassName}
        buttonsProps={buttonsProps}
        description={description}
        qaName={qaName}
        saveIgnoredFieldNames={saveIgnoredFieldNames}
        title={title}
      >
        {children}
      </SettingsFormSectionContent>
      {after}
    </FormikForm>
  )
}

export default SettingsFormSection
